import { Box } from '@mui/material'
import React from 'react'

export default function Dot({bgColor}:{bgColor:string}) {
  return (
     <Box sx={{height:10,width:10, borderRadius:50, backgroundColor:bgColor}}>
     </Box>
  )
}
